import { slideUp, slideDown } from "../accordion/_index";
const HeaderMenuToggle = () => {
    const headerButton = document.getElementsByClassName('js-menu-button')[0];
    if (!headerButton) return;

    const container = document.getElementsByClassName('js-menu-wrap')[0];
    const items = container.querySelectorAll('.l-header__items');
    const line = document.getElementsByClassName('js-menu-line');
    const topNews = document.getElementsByClassName('c-top-news')[0];

    Array.from(items).forEach(item => {
        item.addEventListener('click', () => {
            if (!item.classList.contains('js-menu-down')) {
                Toggle();
            } else {
                SubToggle();
            }
        })
    });

    const SubToggle = () => {

    }

    const Toggle = () => {
        if (!container.classList.contains('is-open')) {
            container.classList.add('is-open');
            headerButton.classList.add('is-open');
            Array.from(line).forEach((elm) => {
                elm.classList.add('is-open');
            })
            if (topNews) {
                slideUp(topNews);
            }
        } else {
            container.classList.remove('is-open');
            headerButton.classList.remove('is-open');
            Array.from(line).forEach((elm) => {
                elm.classList.remove('is-open');
            })
            if (topNews && !topNews.classList.contains('is-none')) {
                slideDown(topNews);
            }
        }
    }

    headerButton.addEventListener('click', () => {
        if (!container) {
            console.log('メニュー要素が見つかりません');
            return;
        }
        Toggle();
    })
}

HeaderMenuToggle();

const FixMenu = () => {
    const menu = document.getElementsByClassName('js-fix-bottom')[0];
    const topNews = document.getElementsByClassName('c-top-news')[0];
    if (menu) {
        document.addEventListener('scroll', () => {
            let scroll_y = window.scrollY;
            if (scroll_y > 500) {
                menu.classList.add('active');
                if (topNews) {
                    if (window.getComputedStyle(topNews).display !== 'none') {
                        slideUp(topNews);
                        topNews.classList.add('is-none');
                    }
                }
            }
            if (scroll_y < 500) {
                menu.classList.remove('active');
                if (topNews) {
                    if (window.getComputedStyle(topNews).display === 'none') {
                        slideDown(topNews);
                        topNews.classList.remove('is-none');
                    }
                }
            }
        })
    }
}

FixMenu();